import { Compass, CalendarClock, Languages } from "lucide-react";
import { ChapterLabel, Reveal } from "@/components/landing/Reveal";

const PAINS = [
    {
        icon: Compass,
        title: "No Guesswork",
        copy: "Know your options before arriving.",
        testId: "pain-no-guesswork",
    },
    {
        icon: CalendarClock,
        title: "No Last-Minute Stress",
        copy: "Secure your VIP experience in advance.",
        testId: "pain-no-stress",
    },
    {
        icon: Languages,
        title: "No Language Barrier",
        copy: "Our concierge handles the booking process for you.",
        testId: "pain-no-language-barrier",
    },
];

const Problem = () => (
    <section
        id="problem"
        data-testid="problem-section"
        className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36"
    >
        <Reveal>
            <ChapterLabel number="Nº 01" title="The Problem" testId="problem-label" />
        </Reveal>
        <Reveal delay={0.1}>
            <h2 className="mt-8 max-w-3xl font-serif text-3xl font-medium leading-tight tracking-tight text-ivory md:text-5xl">
                DON'T WASTE YOUR NIGHT{" "}
                <span className="italic text-gold">FIGURING IT OUT.</span>
            </h2>
        </Reveal>
        <Reveal delay={0.15}>
            <p className="mt-8 max-w-2xl text-sm leading-relaxed text-muted md:text-base">
                Getting into the right club is easy. Getting the right table,
                the right location, the right package and the right experience
                isn't.
            </p>
        </Reveal>

        <div className="mt-16 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
            {PAINS.map((p, i) => (
                <Reveal key={p.title} delay={0.1 + i * 0.1} className="h-full">
                    <div
                        data-testid={p.testId}
                        className="group flex h-full flex-col gap-6 bg-[#0A0A0A] p-10 transition-colors duration-500 hover:bg-[#0F0F0F]"
                    >
                        <p.icon
                            size={26}
                            strokeWidth={1.25}
                            className="text-gold transition-transform duration-500 group-hover:-translate-y-1"
                        />
                        <div>
                            <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-ivory">
                                {p.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-muted">
                                {p.copy}
                            </p>
                        </div>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);

export default Problem;
